<div class="col-lg-12 ml-2 data-sect">

    <h3>Excel List</h3>

    <table
        class="table"
        [svData]="data"
        #sv="svDataTable"
        [svRowsOnPage]="pageSize"
        *ngIf="data && data.length > 0"
    >
        <thead>
            <tr>
                <th>Category</th>
                <th
                    class="text-center"
                   
                >
                    File Name
                </th>
                <th
                    
                    class="text-center"
                >
                    Created Date/Time
                </th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of sv.data">
                <td
                    [display]="item.category"
                    [tooltip]="item.category"
                    placement="top"
                    show-delay="300"
                >
                    {{ item.category }}
                </td>

                <td
                    [display]="item.fileName"
                    [tooltip]="item.fileName"
                    placement="top"
                    show-delay="300"
                    class="text-center"
                >
                    {{ item.fileName }}
                </td>

                <td
                    class="text-center"
                    [display]="item.createDate"
                    [tooltip]="item.createDate"
                    placement="top"
                    show-delay="300"
                >
                    {{ item.createDate}}
                </td>

            </tr>
        </tbody>
        <tfoot *ngIf="data?.length > pageSize">
            <tr>
                <td
                    colspan="5"
                    class="center-paginator"
                >
                    <sv-bootstrap-paginator></sv-bootstrap-paginator>
                </td>
            </tr>
        </tfoot>
    </table>

    <div *ngIf="data?.length <= 0">
        <p class="no-data">No data found</p>
    </div>

</div>
